// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, "\n.sidebar-table-wrap[data-v-c00e09b0] {\n\tpadding: 0 8px;\n}\n.sidebar-table[data-v-c00e09b0] {\n\twidth: 100%;\n\tfont-size: 13px;\n}\n", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
